import React, { memo } from 'react';
import { Range } from '@nykaa/price-filter-shared';
import { styled } from '@nykaa/ui-components';
import { useDispatch } from 'react-redux';


const Wrapper = styled.div`
  width: 100%;
  height: 200px;
  label {
    ${({ theme }) => theme.typography.bodySmall};
  }
  p[data-title="rangeTitle"] {
    ${({ theme }) => theme.typography.bodySmall};
    margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  }
  div[data-title="rangeSlider"] {
    margin: auto;
    width: 94%;
  }
`;


const PriceRange = (props: any) => {
  const {
    filterData,
    handleFilterChange,
    activeFilters = {},
    isApiFailed = false,
    handleResetApiStatus: resetApiStatus = () => {},
    itemsCount = 0,
    isClearAll = false,
  } = props;
  const dispatch = useDispatch();
  const handleResetApiStatus = () => {
    resetApiStatus()(dispatch);
  };
  return (
    <Wrapper>
      <Range
        timeout={500}
        resultCount={itemsCount}
        isClearAll={isClearAll}
        filterData={filterData}
        isApiFailed={isApiFailed}
        activeFilters={activeFilters}
        handleFilterChange={handleFilterChange}
        handleResetApiStatus={handleResetApiStatus}
        allowTouchEvents
      />
    </Wrapper>
  );
};

export default memo(PriceRange);
